import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Button, Col, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import arapaimalake from './images/Rectangle 230 (1).png';
import mainlake from './images/exotic_main_lake.png';
import moment from 'moment';
import axios from 'axios';
import { Calendar } from 'react-multi-date-picker';
import dayjs from 'dayjs';
import { useGlobalState } from './GlobalState';

function FishingSection({
  data,
  lakes,
  accommodationDates,
  handleChange,
  setCollapseVisible,
}) {
  const [packageData, setPackageData] = useGlobalState('packageData');
  let accommodation = data?.accomodation.include === 'yes';
  const AccommodationFishingLake = lakes?.filter(
    (lake) => lake?.lake_type == 'fishing'
  );
  const FishingLake = lakes?.filter(
    (lake) =>
      lake?.lake_type !== 'fishing' && lake?.lake_type !== 'accommodation'
  );
  let includeLakes = accommodation ? AccommodationFishingLake : FishingLake;

  const lakesOptionsArr =
    includeLakes?.map((lake) => ({
      label: lake.lake_name,
      value: lake.lake_id,
    })) || [];
  useEffect(() => {
    const includeLakes = accommodation ? AccommodationFishingLake : FishingLake;

    const lakesOptionsArr =
      includeLakes?.map((lake) => ({
        label: lake.lake_name,
        value: lake.lake_id,
      })) || [];

    if (lakesOptionsArr.length === 1 && data?.fishing?.include === 'yes') {
      handleChange('fishing.lake', lakesOptionsArr[0].value);
    }
  }, [data?.fishing?.include]);
  let disabled =
    !data?.fishing?.lake ||
    !data?.fishing?.swims ||
    !data?.fishing?.angler ||
    !data?.fishing?.fishing_days ||
    data?.fishing?.dates.length !== data?.fishing?.fishing_days;
  useEffect(() => {
    if (disabled) {
      handleChange('fishing.completed', false);
    }
  }, [disabled]);
  const start = accommodationDates?.[0]?.startDate;
  const end = accommodationDates?.[0]?.endDate;
  const accommodation_days =
    start && end
      ? Math.max(1, dayjs(end).diff(dayjs(start), 'day'))
      : data?.accomodation?.include === 'no'
        ? 1
        : 1;
  const [availability, setAvailability] = useState({});
  const getBlockedBookingDates = (_date, lake_id, swims, rooms) => {
    const axios_config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };

    let payload_data = {
      lake_id: lake_id,
      accommodation_details: rooms
        .filter((room) => room.quantity > 0)
        .map((room) => ({
          ticket_type_id: room.product_id,
          quantity: room.quantity,
          arrival_date:
            (accommodationDates?.[0]?.startDate &&
              dayjs(accommodationDates?.[0]?.startDate).isValid() &&
              dayjs(accommodationDates?.[0]?.startDate).format('YYYY-MM-DD')) ||
            '',
          departure_date:
            (accommodationDates?.[0]?.endDate &&
              dayjs(accommodationDates?.[0]?.endDate).isValid() &&
              dayjs(accommodationDates?.[0]?.endDate).format('YYYY-MM-DD')) ||
            '',
        })),
      num_swims: swims,
      date: moment(_date).format('YYYY-MM-DD'),
    };
    axios
      .post(
        'booking/lake/details',

        payload_data,
        axios_config
      )
      .then((res) => {
        if (res.status === 200) {
          const fully_booked_dates = [
            ...new Set(res.data.result?.fully_booked_dates),
          ];
          let availability = generateAvailability(
            _date,
            fully_booked_dates,
            (dayjs(accommodationDates?.[0]?.startDate).isValid() &&
              dayjs(accommodationDates?.[0]?.startDate).format('YYYY-MM-DD')) ||
              null,
            (dayjs(accommodationDates?.[0]?.endDate).isValid() &&
              dayjs(accommodationDates?.[0]?.endDate).format('YYYY-MM-DD')) ||
              null
          );
          setAvailability(availability);
        }
      })
      .catch((err) => {})
      .finally(() => {});
  };

  useEffect(() => {
    if (data?.fishing?.swims) {
      getBlockedBookingDates(
        moment(
          accommodationDates?.[0]?.startDate
            ? accommodationDates?.[0]?.startDate
            : new Date()
        ).format('YYYY-MM-DD'),
        data?.fishing?.lake,
        data?.fishing?.swims,

        data?.accomodation.rooms
      );
    }
  }, [
    data?.fishing?.lake,
    data?.fishing?.swims,
    accommodationDates?.[0]?.startDate,
  ]);
  useEffect(() => {
    handleChange('fishing.dates', [
      dayjs(accommodationDates?.[0]?.startDate).format('YYYY-MM-DD'),
    ]);
  }, [accommodationDates?.[0]?.startDate]);

  function generateAvailability(
    _date,
    fullyBookedDates = [],
    startDate = null,
    endDate = null
  ) {
    const availability = {};
    const fullyBookedSet = new Set(fullyBookedDates);
    const today = dayjs(_date);
    console.log(startDate, endDate);
    const calendarStart = today.subtract(2, 'month');
    const calendarEnd = today.add(2, 'month');

    let current = calendarStart;
    console.log(
      calendarEnd,
      current.isBefore(calendarEnd) || current.isSame(calendarEnd)
    );
    while (current.isBefore(calendarEnd) || current.isSame(calendarEnd)) {
      const dateStr = current.format('YYYY-MM-DD');

      console.log(current, dayjs(startDate));
      if (startDate && endDate) {
        // If range is defined
        if (
          current.isBefore(dayjs(startDate)) ||
          current.isAfter(dayjs(endDate))
        ) {
          availability[dateStr] = 'fully-booked'; // outside range
        } else if (fullyBookedSet.has(dateStr)) {
          availability[dateStr] = 'fully-booked'; // booked within range
        } else {
          availability[dateStr] = 'available'; // available within range
        }
      } else {
        // No range: only mark API-provided dates
        if (fullyBookedSet.has(dateStr)) {
          availability[dateStr] = 'fully-booked';
        }
      }

      current = current.add(1, 'day');
    }

    return availability;
  }

  const maxSelectable = data?.fishing?.fishing_days;
  const handleDateChange = (selectedDates) => {
    // Filter out fully booked dates (so they cannot be selected)
    let filteredDates = selectedDates.filter(
      (date) => availability[date.format('YYYY-MM-DD')] !== 'fully-booked'
    );
    if (filteredDates.length > maxSelectable) {
      filteredDates = filteredDates.slice(0, maxSelectable);
    }
    handleChange(
      'fishing.dates',
      filteredDates.map((selectedDate) =>
        dayjs(selectedDate).format('YYYY-MM-DD')
      )
    );
  };
  useEffect(() => {
    let filteredDates = data?.fishing?.dates;
    if (filteredDates.length > maxSelectable) {
      filteredDates = filteredDates.slice(0, maxSelectable);
    }
    handleChange(
      'fishing.dates',
      filteredDates.map((selectedDate) =>
        dayjs(selectedDate).format('YYYY-MM-DD')
      )
    );
  }, [maxSelectable]);

  let isOverlayActive =
    !data?.fishing?.lake ||
    data?.fishing?.swims === 0 ||
    data?.fishing?.fishing_days === 0;

  return (
    <div>
      <Row gutter={[10, 20]}>
        <Col xs={24} sm={24} lg={24} xl={10}>
          <div>
            <div className='gSemiBold sb-blue-900'>Select your lake</div>
            <Select
              className='w-full gMedium'
              disabled={data?.fishing?.include === 'no'}
              value={data?.fishing?.lake}
              options={lakesOptionsArr}
              //   style={{ flex: 1, maxWidth: 250 }}
              onChange={(value) => handleChange('fishing.lake', value)}
            />
          </div>
          <div className='mg-top-10'>
            <div className='display-flex-row justify-between w-full mg-bottom-10'>
              <div className='sb-blue-900 gSemiBold'>No. Of Anglers:</div>
              <div className='display-flex-row'>
                <button
                  className='icon-button'
                  disabled={
                    data?.fishing?.include === 'no' ||
                    packageData ||
                    data.fishing.angler === 0
                  }
                  onClick={() => {
                    const updatedAnglers = Math.max(0, data.fishing.angler - 1);
                    const maxAnglersPossible = data.fishing.swims * 2;

                    // If reducing angler makes swim capacity too high, adjust swim down
                    const requiredSwims = Math.max(
                      Math.ceil(updatedAnglers / 2),
                      updatedAnglers // if 1 angler per swim
                    );

                    handleChange('fishing.angler', updatedAnglers);

                    if (data.fishing.swims > requiredSwims) {
                      handleChange('fishing.swims', requiredSwims);
                    }
                  }}
                >
                  <MinusCircleOutlined
                    style={{
                      color:
                        packageData || data?.fishing?.angler === 0
                          ? '#CCD3D9'
                          : '#5C6166',
                    }}
                  />
                </button>
                <div>{data?.fishing?.angler}</div>
                <button
                  className='icon-button'
                  disabled={
                    data?.fishing?.include === 'no' ||
                    packageData ||
                    (data?.accomodation?.include === 'yes' &&
                      data?.fishing?.angler >=
                        data?.accomodation?.guests?.adults)
                  }
                  onClick={() => {
                    const updatedAnglers = Math.max(
                      0,
                      data.fishing?.angler + 1
                    );
                    const requiredSwims = Math.ceil(updatedAnglers / 2); // 2 anglers per swim
                    const currentSwims = data.fishing?.swims || 0;

                    handleChange('fishing.angler', updatedAnglers);

                    if (currentSwims < requiredSwims) {
                      handleChange('fishing.swims', requiredSwims);
                    }
                  }}
                >
                  <PlusCircleOutlined
                    style={{
                      color:
                        data?.fishing?.include === 'no' ||
                        packageData ||
                        (data?.accomodation?.include === 'yes' &&
                          data?.fishing?.angler >=
                            data?.accomodation?.guests?.adults)
                          ? '#CCD3D9'
                          : '#5C6166',
                    }}
                  />
                </button>
              </div>
            </div>
            <div className='display-flex-row justify-between w-full mg-bottom-10'>
              <div className='sb-blue-900 gSemiBold'>No. Of swims:</div>
              <div className='display-flex-row'>
                <button
                  className='icon-button'
                  disabled={
                    data?.fishing?.include === 'no' ||
                    packageData ||
                    data.fishing?.swims <= Math.ceil(data?.fishing?.angler / 2)
                  }
                  onClick={() =>
                    handleChange(
                      'fishing.swims',
                      Math.max(
                        Math.ceil(data?.fishing?.angler / 2),
                        data.fishing?.swims - 1
                      )
                    )
                  }
                >
                  <MinusCircleOutlined
                    style={{
                      color:
                        data?.fishing?.include === 'no' ||
                        packageData ||
                        data.fishing?.swims <=
                          Math.ceil(data?.fishing?.angler / 2)
                          ? '#CCD3D9'
                          : '#5C6166',
                    }}
                  />
                </button>
                <div>{data?.fishing?.swims}</div>
                <button
                  className='icon-button'
                  disabled={
                    data?.fishing?.include === 'no' ||
                    packageData ||
                    data.fishing?.swims >= data?.fishing?.angler
                  }
                  onClick={() =>
                    handleChange(
                      'fishing.swims',
                      Math.max(0, data.fishing?.swims + 1)
                    )
                  }
                >
                  <PlusCircleOutlined
                    style={{
                      color:
                        data?.fishing?.include === 'no' ||
                        packageData ||
                        data?.fishing?.swims >= data?.fishing?.angler
                          ? '#CCD3D9'
                          : '#5C6166',
                    }}
                  />
                </button>
              </div>
            </div>
            <div className='display-flex-row justify-between w-full mg-bottom-10'>
              <div className='sb-blue-900 gSemiBold'>No. Of fishing days:</div>
              <div className='display-flex-row'>
                <button
                  className='icon-button'
                  disabled={
                    data?.fishing?.include === 'no' ||
                    packageData ||
                    data.fishing?.fishing_days === 0
                  }
                  onClick={() =>
                    handleChange(
                      'fishing.fishing_days',
                      Math.max(0, data.fishing?.fishing_days - 1)
                    )
                  }
                >
                  <MinusCircleOutlined
                    style={{
                      color:
                        data?.fishing?.include === 'no' ||
                        packageData ||
                        data?.fishing?.fishing_days === 0
                          ? '#CCD3D9'
                          : '#5C6166',
                    }}
                  />
                </button>
                <div>{data?.fishing?.fishing_days}</div>
                <button
                  className='icon-button'
                  disabled={
                    data?.fishing?.include === 'no' ||
                    packageData ||
                    (accommodation_days &&
                      data?.fishing?.fishing_days >= accommodation_days)
                  }
                  onClick={() =>
                    handleChange(
                      'fishing.fishing_days',
                      Math.max(0, data.fishing?.fishing_days + 1)
                    )
                  }
                >
                  <PlusCircleOutlined
                    style={{
                      color:
                        data?.fishing?.include === 'no' ||
                        packageData ||
                        (accommodation_days &&
                          data?.fishing?.fishing_days >= accommodation_days)
                          ? '#CCD3D9'
                          : '#5C6166',
                    }}
                  />
                </button>
              </div>
            </div>
          </div>
          <div className=''>
            <div
              className={`fishing-package-overlay justify-center pd-top-10 pd-bottom-10  ${
                isOverlayActive ? 'active' : ''
              }`}
            >
              {isOverlayActive && (
                <div className='overlay-message'>
                  <div className='text fs-18 gSemiBold'>
                    Please complete the no. of anglers, swims and fishing days
                    to see availability
                  </div>
                </div>
              )}
              <div>
                <div className='gSemiBold sb-blue-900 mg-bottom-10'>
                  Select Your Fishing Dates:
                </div>

                <Calendar
                  multiple
                  value={data?.fishing?.dates}
                  key={dayjs(data?.fishing?.dates[0]).format('YYYY-MM-DD')}
                  onChange={handleDateChange}
                  className='fishing-calendar  gRegular'
                  onMonthChange={({ month, year }) => {
                    const monthStart = moment(
                      `${year}-${month < 10 ? `0${month}` : month}-01`
                    );

                    getBlockedBookingDates(
                      moment(monthStart).format('YYYY-MM-DD'),
                      data?.fishing?.lake,
                      data?.fishing?.swims,

                      data?.accomodation.rooms
                    );
                  }}
                  mapDays={({ date }) => {
                    const formattedDate = date.format('YYYY-MM-DD');
                    const today = moment().format('YYYY-MM-DD');
                    const isBeforeToday = formattedDate < today;
                    const isSelected = data?.fishing?.dates.some(
                      (selectedDate) =>
                        dayjs(selectedDate).format('YYYY-MM-DD') ===
                        formattedDate
                    );
                    const isFullyBooked =
                      availability[formattedDate] === 'fully-booked';

                    let backgroundColor = '#dae8d8';
                    let textColor = 'black';
                    let border = 'none';
                    let borderRadius = '0px'; // Square box style
                    let pointerEvents = 'auto'; // Allow selection by default
                    let opacity = 1;

                    // Apply availability-based full box colors
                    if (availability[formattedDate] === 'available') {
                      backgroundColor = '#dae8d8';
                    }
                    if (availability[formattedDate] === 'partially-booked') {
                      backgroundColor = 'orange';
                      textColor = 'white';
                    }
                    if (isFullyBooked) {
                      backgroundColor = '#DCE1E5';
                      textColor = '#8A9299';

                      pointerEvents = 'none'; // Disable selection
                      // Reduce opacity to indicate it's disabled
                    }

                    // If selected, add a circular highlight inside the box
                    if (isSelected) {
                      backgroundColor = '#28A973'; // Selected date is blue
                      textColor = 'white';
                      // White border for contrast
                      borderRadius = '50%'; // Circular selection inside the box
                    }

                    if (isBeforeToday) {
                      backgroundColor = '#FFB2B2';
                      textColor = '#D65D5D';
                      pointerEvents = 'none';
                      opacity = 0.6;
                    }

                    return {
                      style: {
                        backgroundColor,
                        // width: "100%",
                        color: textColor,
                        border,
                        borderRadius,
                        textAlign: 'center',
                        padding: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pointerEvents, // Disables click on fully booked dates
                        opacity, // Visual indication of disabled dates
                      },
                    };
                  }}
                />
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} lg={24} xl={14}>
          <div className='fishing-container'>
            <Row gutter={[16, 16]} className='info-section'>
              <Col
                xs={{ order: 2, span: 24 }}
                xl={{ order: 1, span: 14 }}
                className='text-content'
              >
                <h4 className='section-title'>The Main Lake</h4>
                <p className='gRegular sb-blue-900 fs-12'>
                  More than a hundred of the fish in this lake are in excess of
                  the 200lb mark, including a number of record-size specimens up
                  to 200lb, ensuring that even the most die-hard of Specimen
                  Hunters has a long list of targets to consider during each and
                  every visit to us, which is why so many of our anglers return
                  year on year.
                </p>
              </Col>
              <Col
                xs={{ order: 1, span: 24 }}
                xl={{ order: 2, span: 10 }}
                className='image-container'
              >
                <img src={mainlake} alt='Main Lake' className='info-image' />
              </Col>
            </Row>

            <Row gutter={[16, 16]} className='info-section'>
              <Col xs={24} xl={10} className='image-container'>
                <img
                  src={arapaimalake}
                  alt='Arapaima Lake'
                  className='info-image'
                />
              </Col>
              <Col xs={24} xl={14} className='text-content'>
                <h4 className='section-title'>The Arapaima Lake</h4>
                <p className='gRegular sb-blue-900 fs-12'>
                  Our Day Trip Lake is designed and stocked for fishermen who do
                  not have the time to spend their holiday fishing due to other
                  commitments but they do want to catch an Arapaima!
                </p>
                <p className='gRegular sb-blue-900 fs-12'>
                  We have created a lake that can cater for large groups of
                  customers by introducing a large number of Arapaima.
                </p>
              </Col>
            </Row>

            <Row className='info-section'>
              <Col xs={24} className='full-width'>
                <h4 className='section-title'>
                  Things to know about fishing at EFT
                </h4>
                <p className='gRegular sb-blue-900 fs-12'>
                  The Main Lake is predominantly for guests staying at the
                  resort, while the Arapaima lake has been set up for day ticket
                  trips. Anglers traveling through Thailand that want an
                  unforgettable experience targeting Arapaima should seriously
                  consider this lake!
                </p>
              </Col>
            </Row>
          </div>
          <Row justify='center'>
            <Button
              type='primary'
              disabled={disabled}
              className={`continue-btn ${
                disabled ? 'grey-bg-300' : 'sb-blue-bg-700'
              } white fs-18 gSemiBold h-full w-fit`}
              onClick={() => {
                handleChange('fishing', { completed: true, include: 'yes' });
                setCollapseVisible('');
              }}
            >
              Save & Continue
            </Button>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default FishingSection;
